module.exports = __webpack_public_path__ + "img/table-arrow-right.9536c45e.svg";